<template>
  <b-badge :variant="variant">
    {{ title }}
  </b-badge>
</template>

<script>
import { capitalize } from '@/helpers';

export default {
  name: 'CompetitorStatusBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    variant() {
      return this.variants[this.status] ?? 'primary';
    },
    title() {
      return capitalize(this.status);
    },
  },
  data() {
    return {
      variants: {
        new: 'secondary',
        burning: 'warning',
        finished: 'success',
      },
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
